/**
 * Плотность материалов
 */
export default {
  state: {
    bags: [
      {
        id: '50',
        label: '50 мкм',
        priceIncrease: 0, // прибавить к цене
      },
      {
        id: '80',
        label: '80 мкм',
        priceIncrease: 3, // прибавить к цене
      },
      {
        id: '100',
        label: '100 мкм',
        priceIncrease: 5, // прибавить к цене
      },
    ],
  },
}